import { render, staticRenderFns } from "./ModalTributacaoRefact.vue?vue&type=template&id=a7ce5f50&scoped=true"
import script from "./ModalTributacaoRefact.vue?vue&type=script&lang=js"
export * from "./ModalTributacaoRefact.vue?vue&type=script&lang=js"
import style0 from "./ModalTributacaoRefact.vue?vue&type=style&index=0&id=a7ce5f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ce5f50",
  null
  
)

export default component.exports